export default __webpack_public_path__ + "static/media/csv.17437ccd.svg";